import { useState } from 'react'

// Create a unique ID that is stable while the component is mounted.
// Useful for aria attributes that need to refer to other elements by ID.
//
// Note that this is not SSR-safe, as that would probably require a little dependency.
// Should be replaced with SSR-safe React.useOpaqueIdentifier when it's ready.
//
export function useStableId(): string {
  const [id] = useState(() => 'useStableId-' + counter++)
  return id
}

let counter = 0
